export default __webpack_public_path__ + "static/media/hibernate-svgrepo-com.ba57c212.svg";